import React from "react";
import './index.scss';
import { getFontsStyles } from "../../TrayModules/Helper/helper";
import { publishInitiateTvePopup } from "../../../components/AdobeRestV2/V2TveLogin/tve-login-events";

export const TveLoginButton = ({handleLoader, layoutSettings, dataTest='' }) => {
    const { subscribeNowCta} = getFontsStyles( layoutSettings?.fontSetting, layoutSettings?.settings);
    const {subscribeNowCtaBgColor,subscribeNowCtaBorderColor,subscribeNowCtaTextColor} = layoutSettings?.settings || {};
    const subscribeNowCtaStyle = {
        backgroundColor: subscribeNowCtaBgColor,
        borderColor: subscribeNowCtaBorderColor,
        color: subscribeNowCtaTextColor
    }

    const handleTveController = async()=>{
            handleLoader()
            publishInitiateTvePopup(true)
            return true
    };

    return (
        <>
            <button
                aria-label="TV connect"
                className="subscribeBtn site-cta-background-color site-cta-color"
                onClick={handleTveController}
                data-test={dataTest}
                style={{...subscribeNowCta}}
            >
                {window?.app_data?.appcmsPlatform?.navigation?.settings?.primaryCta?.ctaText || 'Link to Tve Provider'}
            </button>
        </>
    );
};
